import styled, { withTheme } from 'styled-components';
import { VictoryAxis, VictoryChart, VictoryLine } from 'victory';

import { LoadingAnimation } from '../../../../ui';

const MarkerWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 24px;
  height: 20px;
  margin-right: 14px;
  margin-left: 6px;
`;

const LegendMarker = styled.div`
  width: 24px;
  height: 2px;
  border-bottom: 2px solid;
`;

const ImportLegendMarker = styled(LegendMarker)`
  border-bottom-color: ${(props) => props.theme.colors.imported};
`;

const ExportLegendMarker = styled(LegendMarker)`
  border-bottom-color: ${(props) => props.theme.colors.exported};
`;

const TariffDetailsChart = ({ loadingImportTariff, loadingExportTariff, importTariff, exportTariff, theme }) => (
  <>
    {loadingImportTariff && loadingExportTariff ? (
      <p className="p-5 mt-1">
        <LoadingAnimation />
      </p>
    ) : (
      <VictoryChart
        height={150}
        width={400}
        padding={{ top: 0, bottom: 40, left: 0, right: -8 }}
        domainPadding={{ x: 0, y: 2 }}
      >
        <VictoryAxis
          tickFormat={(t, i) => (i % 2 === 0 ? t : '')}
          style={{
            tickLabels: {
              angle: -90,
              fontSize: 10,
              fontFamily: 'Poppins',
              textAnchor: 'end',
            },
            grid: { stroke: 'none' },
            ticks: { stroke: 'none' },
            axis: { stroke: 'none' },
          }}
        />
        {!!importTariff && (
          <VictoryLine
            data={importTariff}
            interpolation="step"
            style={{
              data: { stroke: theme.colors.imported, strokeWidth: 2 },
            }}
          />
        )}
        {!!exportTariff && (
          <VictoryLine
            data={exportTariff}
            interpolation="step"
            style={{
              data: { stroke: theme.colors.exported, strokeWidth: 2 },
            }}
          />
        )}
      </VictoryChart>
    )}
    <div className="d-flex align-items-center justify-content-center mt-3">
      <span className="mx-2 d-flex align-items-center">
        <MarkerWrapper>
          <ImportLegendMarker />
        </MarkerWrapper>
        Import
      </span>
      <span className="mx-2 d-flex align-items-center">
        <MarkerWrapper>
          <ExportLegendMarker />
        </MarkerWrapper>
        Export
      </span>
    </div>
  </>
);

export default withTheme(TariffDetailsChart);
